import React from 'react'
import styled, { DefaultTheme } from 'styled-components'
import { Link } from 'react-router-dom'

// transient styled items (https://medium.com/@probablyup/introducing-transient-props-f35fd5203e0c)
interface Props {
  $isActivated: boolean
  $specialColor?: string
}

function getColor(
  theme: DefaultTheme,
  isActivated: boolean,
  specialColor?: string
): string {
  return isActivated
    ? theme.modeButtonTextColorActivated // always white in light, black in dark
    : specialColor
    ? specialColor
    : theme.modeButtonTextColorUnactivated
}

function getBgColor(
  theme: DefaultTheme,
  isActivated: boolean,
  specialColor?: string
): string {
  return isActivated
    ? specialColor
      ? specialColor
      : theme.modeButtonBackgroundColorActivated
    : theme.modeButtonBackgroundColorUnactivated
}

const ModeButton = styled(Link)<Props>`
  color: ${({ $isActivated, theme, $specialColor }) =>
    getColor(theme, $isActivated, $specialColor)};
  background-color: ${({ $isActivated, theme, $specialColor }) =>
    getBgColor(theme, $isActivated, $specialColor)};
  border: 0;
  display: inline-block;
  cursor: pointer;
  justify-content: space-between;
  overflow: hidden;
  outline: none;
  font-weight: bold;
  text-decoration: none;
  text-align: center;
  border-radius: 1.75rem;
  padding: 0.8rem 1.2rem;
  font-size: 1.6rem;

  /* Tablets */
  @media (max-width: 1400px) {
    font-size: 1.5rem;
  }

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 1.75rem;
  }
`

export default ModeButton
